/**
 * Anonymní statistika návštěvnosti (Robin 5. 11. 2026).
 * Bez cookies a bez localStorage — pošle jen cestu (bez parametrů) a odkud host přišel, na vlastní server.
 * Server neukládá IP adresu; prohlížeče s Do-Not-Track / Global Privacy Control se neměří vůbec.
 */
import { apiUrl } from './api'

let last = ''
let first = true

function trackView() {
  try {
    const nav = navigator as Navigator & { globalPrivacyControl?: boolean }
    if (nav.doNotTrack === '1' || nav.globalPrivacyControl) return
    const path = location.pathname + (location.hash || '').split('?')[0]
    if (path === last) return
    last = path
    const body = JSON.stringify({ path, ref: first ? document.referrer : '' })
    first = false
    const url = apiUrl('/api/sobacov/stats/hit')
    const blob = new Blob([body], { type: 'text/plain' })
    if (!(nav.sendBeacon && nav.sendBeacon(url, blob))) {
      fetch(url, { method: 'POST', body, keepalive: true, credentials: 'omit' }).catch(() => {})
    }
  } catch {
    /* statistika nesmí nikdy rozbít web */
  }
}

export function initStats() {
  trackView()
  window.addEventListener('hashchange', () => setTimeout(trackView, 50))
}
